export const rules = {
  cutOrder: [{ required: true }],
  order: [{ required: true }],
  step: [{ required: true }],
};
